import { NgFor, NgTemplateOutlet } from '@angular/common';
import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	OnDestroy,
	OnInit,
	ViewEncapsulation,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import {
	FuseNavigationService,
	FuseVerticalNavigationComponent,
} from '@fuse/components/navigation';
import { AvailableLangs, TranslocoService } from '@ngneat/transloco';
import { TranslateService } from '@ngx-translate/core';
import { LANGUAGES } from 'app/config/language.constants';
import { SharedModule } from 'app/shared/shared.module';
import { SessionStorageService } from 'ngx-webstorage';
// import { PrimeNGConfig } from 'primeng/api';

interface Scope {
	languages: string[];
}

@Component({
	selector: 'languages',
	templateUrl: './languages.component.html',
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
	exportAs: 'languages',
	imports: [SharedModule, MatButtonModule, MatMenuModule, NgTemplateOutlet, NgFor],
})
export class LanguagesComponent implements OnInit, OnDestroy {
	scope: Scope = {
		languages: LANGUAGES,
	};
	availableLangs: AvailableLangs;
	activeLang: string;
	flagCodes: any;

	/**
	 * Constructor
	 */
	constructor(
		private _changeDetectorRef: ChangeDetectorRef,
		private _fuseNavigationService: FuseNavigationService,
		private _translocoService: TranslocoService,
		private _translateService: TranslateService,
		// private _config: PrimeNGConfig,
		private sessionStorageService: SessionStorageService
	) {}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {
		// Get the available languages from transloco
		this.availableLangs = this._translocoService.getAvailableLangs();

		// Subscribe to language changes
		this._translocoService.langChanges$.subscribe((activeLang) => {
			// Get the active lang
			this.activeLang = activeLang;

			// Customs
			this._translate(activeLang);
		});

		// Set the country iso codes for languages for flags
		this.flagCodes = {
			en: 'us',
			'pt-br': 'br',
			es: 'es',
		};
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	/**
	 * Set the active lang
	 *
	 * @param lang
	 */
	setActiveLang(lang: string): void {
		// Set the active lang
		this._translocoService.setActiveLang(lang);
		this._translate(lang);
	}

	/**
	 * Track by function for ngFor loops
	 *
	 * @param index
	 * @param item
	 */
	trackByFn(index: number, item: any): any {
		return item.id || index;
	}

	changeLanguage(languageKey: string): void {
		this._translate(languageKey);
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Private methods
	// -----------------------------------------------------------------------------------------------------

	private _translate(lang: string) {
		this.sessionStorageService.store('locale', lang);
		this._translateService.use(lang);
		// this._translateService.get('primeng').subscribe((res) => this._config.setTranslation(res));
	}
}
